import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-caption" }
const _hoisted_2 = ["onClick"]

import { ref, computed } from 'vue';
import {
  startOfWeek,
  addDays,
  format,
  parse,
  isSameDay,
  isSameMinute,
  setHours,
  setMinutes,
  parseISO, isWithinInterval, addMinutes
} from 'date-fns';



export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarWeek',
  props: {
    baseDate: {},
    events: {},
    onCreate: { type: Function },
    calendarConfig: {}
  },
  setup(__props: any) {

const props = __props;

const timeStep = ref(30); // minutos entre bloques, puede ser 30, 60, etc.

const generateTimeSlots = () => {
  const slots: string[] = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let min = 0; min < 60; min += timeStep.value) {
      const h = hour.toString().padStart(2, '0');
      const m = min.toString().padStart(2, '0');
      slots.push(`${h}:${m}`);
    }
  }
  return slots;
};

const timeSlots = computed(() => generateTimeSlots());

const weekDays = computed(() => {
  const start = startOfWeek(props.baseDate, { weekStartsOn: 1 });
  return Array.from({ length: 7 }, (_, i) => ({
    label: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'][i],
    date: addDays(start, i),
  }));
});

function getEventsForDateTime(dayDate: Date, time: string) {
  const [hour, minute] = time.split(':').map(Number);
  const slotStart = setMinutes(setHours(dayDate, hour), minute);
  const slotEnd = addMinutes(slotStart, timeStep.value);

  const dateField = props.calendarConfig?.dateField || 'date';

  return props.events.filter(event => {
    const rawDate = event.original?.[dateField];
    const eventDate = typeof rawDate === 'string' ? parseISO(rawDate) : new Date(rawDate);
    return isWithinInterval(eventDate, { start: slotStart, end: slotEnd });
  });
}

function handleCreate(date: Date, time: string) {
  const [hour, minute] = time.split(':').map(Number);
  const fullDate = setMinutes(setHours(date, hour), minute);
  props.onCreate?.({ date: fullDate.toISOString() });
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-4 pt-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "text-center ma-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "1",
                class: "pa-1"
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDays.value, (day) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: day.label,
                  class: "text-caption text-grey-darken-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(day.label), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(format)(day.date, 'dd/MM')), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "1" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeSlots.value, (slot) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: slot,
                      class: "time-slot-label"
                    }, _toDisplayString(slot), 1))
                  }), 128))
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDays.value, (day) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: day.label,
                  class: "border-left",
                  style: {"border-left":"1px solid #ccc"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeSlots.value, (slot) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: slot,
                        class: "time-slot-cell",
                        onClick: ($event: any) => (handleCreate(day.date, slot))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getEventsForDateTime(day.date, slot), (event) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: event.id,
                            class: "event-chip"
                          }, [
                            _createVNode(_component_v_chip, {
                              color: "white",
                              size: "x-small",
                              class: "ma-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(event.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128))
                      ], 8, _hoisted_2))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})